import { useCallback } from 'react'
import { Appointment } from '@myapp/contract'
import { useUpsertBreak, useBreakBlocks } from '../../../entities/time-entry'
import { DefaultDurations } from '../../../shared/lib/blockRanges'
import { ResolvedBreak } from '../../../entities/time-entry/model/useBreakBlock'
import { useBreakInteraction } from './useBreakInteraction'

type HasCollisionFn = (
  iso: string,
  dur: DefaultDurations,
  techId: string,
  excludeId?: string,
  excludeTaskId?: number,
  excludeBreakForTechnicianId?: string,
) => boolean

interface Options {
  technicians?: { technicianId: string; appointments: Appointment[]; workingDays: number[]; shiftStart: string | null; shiftEnd: string | null }[]
  breakBlocks: Map<string, ResolvedBreak>
  dayIso: string
  hasCollision?: HasCollisionFn
}

export function useBreakEdit({ technicians, breakBlocks, dayIso, hasCollision }: Options) {
  const upsertBreak = useUpsertBreak()

  const handleBreakMoved = useCallback(
    (technicianId: string, newStartTimeIso: string) => {
      upsertBreak.mutate({
        assignedTechnicianId: Number(technicianId),
        date: dayIso,
        startTime: newStartTimeIso,
      })
    },
    [upsertBreak, dayIso],
  )

  return useBreakInteraction({
    technicians,
    breakBlocks,
    dayIso,
    onBreakMoved: handleBreakMoved,
    hasCollision,
  })
}
